import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ConditionalsPayload, QueryType } from 'dashboard/models/graph-query';
import {
  GraphQueryTemplate,
  GraphQueryTemplateId,
  sanitizeGraphQueryTemplate,
} from 'dashboard/models/graph-query-template';
import { setGraphQueryTemplate } from 'dashboard/redux/actions/graph-query-template';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadGraphQueryTemplate(
  graphQueryTemplateId: GraphQueryTemplateId,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const { data: graphQueryTemplate } =
      await SessionClientDashboard.getResource<GraphQueryTemplate>(
        ApiEndpoint.GraphQueryTemplate,
        graphQueryTemplateId,
      );

    dispatch(setGraphQueryTemplate(sanitizeGraphQueryTemplate(graphQueryTemplate)));
  };
}

export function saveGraphQueryTemplate(
  name: string,
  description: string,
  type: QueryType,
  payload: ConditionalsPayload,
  graphQueryTemplateId: string | null = null,
): DashboardThunkAction {
  return async (dispatch: Dispatch) => {
    if (graphQueryTemplateId != null) {
      const { data: graphQueryTemplate } =
        await SessionClientDashboard.updateResource<GraphQueryTemplate>({
          id: graphQueryTemplateId,
          type: ApiModel.GraphQueryTemplate,
          attributes: {
            name,
            description,
            type,
            payload,
          },
        });
      dispatch(setGraphQueryTemplate(sanitizeGraphQueryTemplate(graphQueryTemplate)));
    } else {
      const { data: graphQueryTemplate } =
        await SessionClientDashboard.postResourceCreate<GraphQueryTemplate>({
          type: ApiModel.GraphQueryTemplate,
          attributes: {
            name,
            description,
            type,
            payload,
          },
        });

      dispatch(setGraphQueryTemplate(sanitizeGraphQueryTemplate(graphQueryTemplate)));
    }
  };
}
